//引入axios 
import request from '../utils/request'// 这里是引入咱们的axios用axios来进行异步接口请求
//个人信息接口
export function getUserInfo(data){
    return request({
        url:'/api/user/getUserInfo',
        method:'post',
        data,  
    })
}

//比如说接口为注册接口
export function getCitywuliu(data){
    return request({
        url:'/api/index/logistics',
        method:'post',
        data,  
    })
}
//解除微信授权
export function removeWxAuth(data){
    return request({
        url:'/api/user/removeWxAuth',
        method:'post',
        data,  
    })
}
//修改信息
export function saveUserInfo(data){
    return request({
        url:'/api/user/saveUserInfo',
        method:'post',
        data,  
    })
}
//修改密码
export function changePassword(data){
    return request({
        url:'/api/user/changePassword',
        method:'post',
        data,  
    })
}


